import React, { Component } from "react";
import $ from "jquery";
import Util from "../../util/common";

import ClassNames from "classnames";

const firstExpWords = [];
const secondExpWords = [];
class SearchBar extends Component {
  constructor(opts) {
    super(opts);
    this.expandAuction = this.expandAuction.bind(this);
    this.searchKey = this.searchKey.bind(this);
  }

  state = {
    expand: false,
    flag: false,
  };

  searchKey(keyword) {
    //价格排序
    const obj = Util.getUrlParms();
    //清理排序
    obj.keywords = keyword;
    const { location } = window;

    const origin = Util.getLocationOrigin();

    const _url = origin + location.pathname;
    const path = $.param(obj);
    window.location.href = `${_url}?${path}`;
  }

  expandAuction() {
    const { expand, flag } = this.state;
    if (!flag) {
      this.setState({
        flag: true,
        expand: !expand,
      });
    } else {
      this.setState({
        expand: !expand,
      });
    }
  }

  componentDidMount() {
    const el = document.getElementById("relativeWordsWrap");
    const keywordDomList = (el && el.childNodes) || [];

    this.timer = setTimeout(() => {
      keywordDomList.forEach((word) => {
        if (word.offsetTop < 40) {
          firstExpWords.push(word.innerText);
        } else {
          secondExpWords.push(word.innerText);
        }
      });
    }, 0);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const list = this.props.list || [];
    const cls = ClassNames({
      expander: this.state.expand,
    });
    const clss = `l40 h40 clearfix relative over_hid pl15 ${cls}`;
    const { width = 1190 } = this.props;
    const clswarp = ClassNames({
      clearfix: true,
      bor_gray: true,
      //"border-buttom-none": true,
      w_1190: width === 1190,
      w_990: width === 990,
      w_1390: width === 1390,
    });

    return (
      <div className="mt20" data-spm="dh_001">
        <div className={clswarp} id="searchWarp">
          <div className={clss}>
            <span className="col_999 f12 inline_block fl">您是否在找：</span>
            <div className="fl w_82" id="relativeWordsWrap">
              {list.map((item, index) => {
                const obj = Util.getUrlParms();
                //清理排序
                obj.keywords = item;
                obj.exp = window.pageConfig.exp;
                obj.ptid = window.p4pObject && window.p4pObject.ptid || "";
                delete obj.hpageId;
                delete obj.a_o;
                delete obj.outerId;
                const path = $.param(obj);
                return (
                  <a
                    href={`https://1688.com/zw/page.html?hpageId=old-sem-pc-list&${path}`}
                    key={index}
                    className="col_txt txt_center inline_block f12 search_key"
                  >
                    {item}
                  </a>
                );
              })}
            </div>
            {this.state.expand ? (
              <i
                className="iconfont f24 col_999 w_8 expand fr mr10"
                onClick={this.expandAuction}
              >
                &#xe6e3;
              </i>
            ) : (
              <i
                className="iconfont fr f24 col_999 w_8 expand mr10"
                onClick={this.expandAuction}
              >
                &#xe662;
              </i>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default SearchBar;
